import {
  CANCEL_BRAINTREE_SUBSCRIPTION_FAILURE,
  CANCEL_BRAINTREE_SUBSCRIPTION_REQUESTED,
  CANCEL_BRAINTREE_SUBSCRIPTION_SUCCESS,
  FETCH_FAILURE,
  FETCH_REQUESTED,
  FETCH_SUCCESS,
} from 'actiontypes/subscription';
import { fetch as fetchMap } from 'actions/map';
import { fetch as fetchSettings } from 'actions/settings';

import SubscriptionService from 'services/SubscriptionService';
import { Dispatch } from 'redux';
import { ICancelSubscriptionSuccessData, ISubscriptionService } from 'types/subscription';

const service: ISubscriptionService = new SubscriptionService();

/** ----------------------------------------------------------------------------
 * FETCH
 -----------------------------------------------------------------------------*/
export const fetch = () => async (dispatch: Dispatch) => {
  dispatch(fetchSubscriptionRequested());

  try {
    const { data } = await service.fetchSubscription();
    dispatch(fetchSubscriptionSuccess(data));
  } catch (error) {
    dispatch(fetchSubscriptionFailure(error));
  }
};

export const fetchSubscriptionRequested = () => ({ type: FETCH_REQUESTED });

export const fetchSubscriptionSuccess = (data: ICancelSubscriptionSuccessData) => ({
  type: FETCH_SUCCESS,
  payload: data
});

export const fetchSubscriptionFailure = (error: any) => ({
  type: FETCH_FAILURE,
  error: true,
  status: error.response?.status,
});


/** ----------------------------------------------------------------------------
 * CANCEL BRAINTREE SUBSCRIPTION
 -----------------------------------------------------------------------------*/
export const cancelBraintreeSubscription = () => async (dispatch: Function) => {
  dispatch(cancelBraintreeSubscriptionRequested());

  try {
    const { data } = await service.cancelBraintreeSubscription();
    dispatch(cancelBraintreeSubscriptionSuccess(data));
    dispatch(fetchSettings());
    // We also need to update the map --- the House of Chimes is now off limits
    dispatch(fetchMap());
  } catch (error) {
    dispatch(cancelBraintreeSubscriptionFailure(error));
  }
};

export const cancelBraintreeSubscriptionRequested = () => ({ type: CANCEL_BRAINTREE_SUBSCRIPTION_REQUESTED });

export const cancelBraintreeSubscriptionSuccess = (data: ICancelSubscriptionSuccessData) => ({
  type: CANCEL_BRAINTREE_SUBSCRIPTION_SUCCESS,
  payload: {
    isSuccess: data.isSuccess,
    message: data.message,
  },
});

export const cancelBraintreeSubscriptionFailure = (error: any) => ({
  type: CANCEL_BRAINTREE_SUBSCRIPTION_FAILURE,
  error: true,
  status: error.response?.status,
});
